<template>
  <f7-block strong class="no-padding no-margin no-border-top wh-100">

    <l-map :zoom="zoom"
           :center="center"
           :options="mapOptions"
           ref="mapMeteoSynop"
           class="meteo-synop-map"
    >
      <l-control-zoom position="bottomright"  ></l-control-zoom>
      <l-tile-layer
          ref="layerBg"
          :url="url"
          :attribution="attribution"
      />
      <l-tile-layer :url="borderUrl" />
      <l-geo-json
          ref="geoJsonLayer"
          :geojson="synopGeoJsonData"
          :options="geoJsonOptions"
      />
      <l-control :position="'bottomleft'">
        <f7-button class="mv-veliciny-filter-btn text-color-white" fill popover-open=".mv-veliciny-popover" icon-f7="slider_horizontal_3"></f7-button>
      </l-control>

      <l-control v-if="isGeolocationEnabled" :position="'bottomright'">
        <div class="leaflet-bar">
          <a @click="geoLocateMap" role="button"><i class="icon f7-icons" style="font-size: 22px;">placemark_fill</i></a>
        </div>
      </l-control>

      <l-control v-if="isGeolocationEnabled && extraParams.clearBtnVar" :position="'bottomright'">
        <div class="leaflet-bar">
          <a @click="clearMarker" role="button"><i class="icon f7-icons" style="font-size: 22px;">xmark</i></a>
        </div>
      </l-control>



    </l-map>

    <f7-popover class="mv-veliciny-popover">
      <f7-list>
        <f7-list-item radio :checked="selectedVelicina === 'ttt'"
                      value="ttt"
                      popover-close
                      name="velicina"
                      title="Teplota"
                      class="mv-velicina-checkbox"
                      @change="updateVelicinaFilter"
        >
        </f7-list-item>
        <f7-list-item radio :checked="selectedVelicina === 'tlak'"
                      value="tlak"
                      popover-close
                      name="velicina"
                      title="Tlak"
                      class="mv-velicina-checkbox"
                      @change="updateVelicinaFilter"
        >

        </f7-list-item>
        <f7-list-item radio :checked="selectedVelicina === 'v_rychlost'"
                      value="v_rychlost"
                      popover-close
                      name="velicina"
                      title="Vietor"
                      class="mv-velicina-checkbox"
                      @change="updateVelicinaFilter"
        >
        </f7-list-item>
        <f7-list-item radio :checked="selectedVelicina === 'rh'"
                      value="rh"
                      popover-close
                      name="velicina"
                      title="Relatívna vlhkosť"
                      class="mv-velicina-checkbox"
                      @change="updateVelicinaFilter"
        >
        </f7-list-item>

      </f7-list>
    </f7-popover>


  </f7-block>


</template>

<script>
import Axios from "axios";
import SHMUconf from "../js/SHMUconf";
import {latLng} from "leaflet";
import shmuMixin from "../js/mixin";
import {LControl, LControlZoom, LGeoJson, LImageOverlay, LMap, LMarker, LTileLayer} from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';
import geoLocationMixin from "../js/geoLocationMixin";

export default {
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LImageOverlay,
    LGeoJson,
    LControlZoom,
    LControl
  },
  mixins: [
    shmuMixin,
    geoLocationMixin
  ],
  props: {
    mapChanged: Number,
    reloadInvoked: Number,

  },
  data: function () {
    return {
      selectedVelicina: 'ttt',
      mapOptions: {
        zoomControl: false,
        zoomSnap: 0.5,
        maxBounds: [[51.7, 25.79], [45.05, 10.6]],
        minZoom: 6,
        maxZoom: 12
      },
      synopGeoJsonData: {
        "type": "FeatureCollection",
        "crs": {
          "type": "name",
          "properties": {
            "name": "EPSG:4326"
          }
        },
        "features": []
      },
      zoom: 8,
      center: latLng(48.688714, 19.696843),
      url: SHMUconf.MAP_TILE_URL + 'data/datatiles/osm/v1/{z}/{x}/{y}.png',
      borderUrl: SHMUconf.MAP_TILE_URL + 'data/datatiles/hranice_sk/v1/{z}/{x}/{y}.png',
      attribution: '&copy; <a href="http://osm.org/copyright" class="external">OpenStreetMap</a> contributors',

      // geolocation
      extraParams: {
        circleMarkerObject: null,
        pointMarkerObject: null,
        clearBtnVar: false
      },
    };
  },
  watch: {
    mapChanged(v) {
      this.$nextTick(() => {
        this.$refs.mapMeteoSynop.mapObject.invalidateSize();
      });
    },
    reloadInvoked(v) {
      this.loadGeoJsonData();
    }
  },
  computed : {

    geoJsonOptions() {
      const data = this.synopGeoJsonData;
      const sv = this.selectedVelicina;

      this.$nextTick( function () {

        if (this.$refs.mapMeteoSynop.mapObject.getZoom() > 8) {
          document.querySelectorAll(".b-name").forEach( function(el) { el.style.opacity =  1});
        } else {
          document.querySelectorAll(".b-name").forEach( function(el) { el.style.opacity = 0 });
        }

      });

      return {
        onEachFeature: this.onEachFeatureFunction,
        pointToLayer: this.makeSynopPointToLayer,

      };
    },

  },
  mounted() {
    this.loadGeoJsonData();
    this.$nextTick(() => {
      this.initMap();
    });
  },
  updated() {

  },
  destroy() {

  },
  methods: {
    initMap() {
      const self = this;

      this.$$('.leaflet-control-attribution a').each((i, item) => {
        self.$$(item).addClass('external')
      });

      this.$refs.mapMeteoSynop.mapObject.invalidateSize();

      this.$refs.mapMeteoSynop.mapObject.on('zoomend', function (e) {
        if (this.getZoom() > 8) {
          document.querySelectorAll(".b-name").forEach( function(el) { el.style.opacity =  1});
        } else {
          document.querySelectorAll(".b-name").forEach( function(el) { el.style.opacity = 0 });
        }
      });


      // geolocation
      this.locationMapInitEvents(this, this.$refs.mapMeteoSynop.mapObject);


    },
    loadGeoJsonData: function() {
      const self = this;

      let cached_geojson = self.$ls.get('actual_weather_geojson');
      if (cached_geojson !== null) {
        self.synopGeoJsonData = cached_geojson;
        self.isGeoJsonLoaded = true;
        self.$f7.dialog.close();
      } else {


        self.$f7.dialog.preloader('Načítavam...');
        Axios.get(SHMUconf.API_BASE_URL + 'meteo/getweathergeojson', {
          crossDomain: true,
          cache: false,
        })
            .then((response) => {
              if (!response.data.error) {
                self.synopGeoJsonData = response.data;
                self.isGeoJsonLoaded = true;
                self.$ls.set('actual_weather_geojson', self.synopGeoJsonData, 5 * 60 * 1000); // 5 minut
              } else {
                self.$f7.dialog.alert('Nepodarilo sa načítať údaje o aktuálnom počasí', 'Nastala chyba');
              }
              self.$f7.dialog.close();
            }).catch((error) => {
          self.$f7.dialog.close();
          self.$f7.dialog.alert('Nepodarilo sa nadviazať spojenie so serverom SHMÚ', 'Nastala chyba spojenia');
        });

      }
    },
    makeSynopPointToLayer: function(feature, latlng)  {
      const self = this;

      if (!feature.properties.prop_weather[this.selectedVelicina]) return;

      let fp = feature.properties.prop_weather;
      let val = fp[this.selectedVelicina];
      let orig_val = val;
      let addon = '';
      let extra_style = '';


      switch (this.selectedVelicina) {
        case 'ttt': {
          addon = '°C';

          let colors = self.getTemperatureColor(val);
          if (colors) {
            extra_style = "color:"+colors.f_color+"; background-color:"+colors.color;
          }

          break;
        }
        case 'tlak': { addon = ' hPa'; break; }
        case 'rh': { addon = '%'; break; }
        case 'v_rychlost': { addon = '<small> km/h</small>';
        val = this.windKmh(val);
          if (fp.v_smer !== 'BEZV' && fp.v_smer !== null) {
            addon += '<span class="a-wind"><img src="static/shmu/img/svg/wind-b.svg" class="img-wind size15 rot-' + fp['v_smer'].toLowerCase() + '"></span>';
          }

          let colors = self.getWindSpeedColor(orig_val);
          if (colors) {
            extra_style = "color:"+colors.f_color+"; background-color:"+colors.color;
          }

          break;
        }
      }

      let ctnt = '';
      ctnt += '<div class="b-name">' + feature.properties.prop_name + '</div>';
      ctnt += '<div class="b-value" style="'+extra_style+'">' + val + addon +'</div>';

      let divIcon = L.divIcon({className: 'synop-box', html:ctnt, iconAnchor:[30,0]});

      let point = L.marker(latlng, {icon: divIcon});;
      point.bindTooltip(feature.properties.prop_name, { direction:'top', offset: [0, 0] });

      return point;

    },
    onEachFeatureFunction: function(feature, layer)  {
      const self = this;

      layer.on({
        click: function (v) {
          if (v.target.feature.id) {
            self.$f7router.navigate('/aktualne-pocasie/' + v.target.feature.id);
          }
        }
      });

    },

    updateVelicinaFilter(event) {
      const self = this;
      this.selectedVelicina = event.target.value;
      self.$f7.popover.close();

    },
    windKmh: function (ms) {
      if (ms) {
        return Math.round(ms * 3.6 * 10) / 10;
      }
      return null;
    },

    // geolocation
    geoLocateMap() {
      this.locationLocate(this, this.$refs.mapMeteoSynop.mapObject, 10);
    },
    clearMarker() {
      this.locationClearMarker(this, this.$refs.mapMeteoSynop.mapObject);
    },
    onLocationFound(e) {
      this.locationFound(this, this.$refs.mapMeteoSynop.mapObject, e);
    },
    onLocationError(e) {
      this.locationError(this, e);
    }

}

};
</script>

<style lang="scss">
.meteo-synop-map {
  width: 100%;
  height: 100%;
}

.synop-box {
  display: flex;
  flex-direction: column;
  /* min-width: 90px; */
  .b-name {
    color: #fff;
    font-size: 12px;
    font-weight: bold;
    white-space: nowrap;
    text-shadow: -1px -1px 0 #000, 1px 1px 0 #000, -1px 1px 0 #000, 1px -1px 0 #000;
    opacity: 0;
  }
  .b-value {
    background-color: #ffffff;
    color: #000;
    border: 1px solid #aaaaaa;
    text-align: center;
    border-radius: 3px;
    min-width: 50px;
    padding: 3px 2px;
    font-weight:bold;
    font-size: 12px;
    display: inline-block;
    line-height: 100%;
  }

}


</style>
